export const SET_LIST_DATA = "SET_LIST_DATA";
export const SET_LOADING_DATA = "SET_LOADING_DATA";
export const SET_LIST_PAGINATION = "SET_LIST_PAGINATION";
export const SET_LIST_FILTER = "SET_LIST_FILTER";
export const RESET_REDUCER = "RESET_REDUCER";

